import { OeeSettings } from './oeeconfig.model'
import { Cell } from '../event/event.dto';


export default class OeeService {

    fetchcells(): Promise<Cell[]> {
        return fetch('api/cell/cells')
            .then(response => response.json() as Promise<OeeSettings[]>);
    };

    fetchsettings(): Promise<OeeSettings[]> {
        return fetch('api/OeeSettings/list')
            .then(response => response.json() as Promise<OeeSettings[]>);
    };

    /**
     * Posts an OeeSettings to the server
     * @param OeeSettings
     */
    postsetting(oeesettings: OeeSettings): Promise<any> {
        return fetch('api/OeeSettings/addOeeSetting',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(oeesettings)
            })
            .then(response => response.status);
    };

    /**
     * Updates an OeeSettings to the server
     * @param OeeSettings
     */
    updatesetting(oeesettings: OeeSettings): Promise<any> {
        return fetch('api/OeeSettings/updateOeeSetting',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(oeesettings)
            })
            .then(response => response.status);
    };


    /**
     * Posts an deletion request
     * @param OeeSetings
     */
    deletesettings(oeesettings: OeeSettings[]): Promise<any>
    {
        return fetch('api/OeeSettings/deleteOeeSettings',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(oeesettings)
            })
            .then(response => response.status);
    };

}